<template>
  <div>
    <Card>
      <div class="upload-list"  v-if="uploadList.length !== 0" v-for="(item,index) in uploadList" :key="index">
        <img :src="item.material_base64" >
        <div class="upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(index,item.examination_id)" size="30"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index, item.examination_id)" size="30"></Icon>
        </div>
      </div>
      <div class="upload-list"  v-if="editAddmaterialsList.length !== 0 && editOrAdd === 'editMaterials'" v-for="(item,index) in editAddmaterialsList" :key="'edit'+index">
        <img :src="item.material_base64" >
        <div class="upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(index)" size="30"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" size="30"></Icon>
        </div>
      </div>
      <div @click="selectImage" class="ivu-upload" disabled="disabled" style="display: inline-block; width: 98px;">
        <div class="ivu-upload ivu-upload-drag">
          <div style="width: 98px; height: 98px; line-height: 98px;">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </div>
        <ul class="ivu-upload-list"></ul>
      </div>
    </Card>
    <Card v-if="visible && examinationId === ''" style="margin-top: 20px">
      <div>
        <img :src="imageUrl" v-if="visible" style="width: 100%">
      </div>
    </Card>
    <Card v-show="visible && examinationId !== ''&& editOrAdd === 'editMaterials' " style="margin-top: 20px">
      <canvas id="canvas" width="800" height="600" ref="canvas"></canvas>
    </Card>
  </div>
</template>
<script>
export default {
  props: {
    uploadList: {
      type: Array,
      default: null
    },
    editOrAdd: {
      type: String,
      default: 'addMaterials'
    }
  },
  data () {
    return {
      img: new Image(), // 背景图片缓存
      context: {}, // canvas对象
      examinationId: '', // 取材图像ID
      imageUrl: '', // 显示取材图片大图的base64
      visible: false, // 是否显示大图
      materialsMarkList: [], // 取材图像标记信息
      editAddmaterialsList: [] // 修改取材图时，添加的取材图像
    }
  },
  methods: {
    /**
     * describe 初始化绘制信息
     * @author JKD
     * @data 2019/4/20 16:56
     */
    initDraw () {
      // 初始化画布
      this.img.src = this.imageUrl
      const canvas = this.$refs.canvas
      this.context = canvas.getContext('2d')
      this.context.drawImage(this.img, 0, 0, 800, 600)
      this.context.strokeStyle = '#FF0000'
    },
    /**
     * describe 在画布上画图
     * @author JKD
     * @data 2019/4/20 16:57
     */
    showMaterialMark (start_x, start_y, end_x, end_y, mark_type) {
      if (mark_type === 'line') {
        this.context.beginPath()
        this.context.moveTo(start_x, start_y)
        this.context.lineTo(end_x, end_y)
        this.context.stroke()
        this.context.closePath()
      }
      if (mark_type === 'circular') {
        this.paramEllipse(this.context, (start_x + end_x) / 2, (start_y + end_y) / 2,
          (end_x - start_x) / 2, (end_y - start_y) / 2)
      }
      if (mark_type === 'rectangle') {
        this.context.beginPath()
        this.context.strokeRect(start_x, start_y, (end_x - start_x), (end_y - start_y))
        this.context.stroke()
        this.context.closePath()
      }
    },
    /**
     * describe 画圆方法
     * @author JKD
     * @data 2019/4/20 16:57
     */
    paramEllipse (context, x, y, a, b) {
      var step = (a > b) ? 1 / a : 1 / b
      context.beginPath()
      context.moveTo(x + a, y)
      for (var i = 0; i < 2 * Math.PI; i += step) {
        context.lineTo(x + a * Math.cos(i), y + b * Math.sin(i))
      }
      context.closePath()
      context.stroke()
    },
    /**
     * describe 选择取材图片
     * @author JKD
     * @data 2019/4/20 16:58
     */
    selectImage () {
      var materials = window.HandleEvent('openFile')
      materials = JSON.parse(materials)
      let fileSize = (materials.file_size / 1024) / 1024
      if (fileSize > 6) {
        this.$Message['error']({
          background: true,
          content: this.$t('captureImage.sizeOfPictureTip'),
          duration: 3
        })
        return false
      }
      materials['material_base64'] = 'data:image/jpeg;base64,' + materials.material_base64
      if (this.editOrAdd === 'editMaterials') {
        this.editAddmaterialsList.push(materials)
      } else {
        this.uploadList.push(materials)
      }
    },
    /**
     * describe 查看取材图像大图
     * @author JKD
     * @param index 当前取材图像在集合中的下标
     * @param examinationId 取材图像ID
     * @data 2019/4/20 16:59
     */
    handleView (index, examinationId) {
      this.visible = true
      if (this.editOrAdd === 'addMaterials') {
        this.imageUrl = this.uploadList[index].material_base64
      }
      if (this.editOrAdd === 'editMaterials') {
        // ------------canvas------------------------------
        if (examinationId !== '' && examinationId !== undefined) {
          // 获取取材图像base64
          this.imageUrl = this.uploadList[index].material_base64
          this.examinationId = examinationId
          // 初始化绘制信息
          this.initDraw()
          this.materialsMarkList = this.uploadList[index].materials
          for (var i = 0; i < this.materialsMarkList.length; i++) {
            let start_x = this.materialsMarkList[i].start_x
            let start_y = this.materialsMarkList[i].start_y
            let end_x = this.materialsMarkList[i].end_x
            let end_y = this.materialsMarkList[i].end_y
            let mark_type = this.materialsMarkList[i].mark_type
            // 根据坐标信息绘制图像
            this.showMaterialMark(start_x, start_y, end_x, end_y, mark_type)
          }
        } else {
          this.examinationId = ''
          this.imageUrl = this.editAddmaterialsList[index].material_base64
        }
      }
    },
    /**
     * describe 删除选中的取材图像
     * @author JKD
     * @data 2019/4/20 17:01
     */
    async handleRemove (index, examinationId) {
      if (this.editOrAdd === 'addMaterials') {
        this.deleteMaterialFromUploadList(index)
      }
      if (this.editOrAdd === 'editMaterials') {
        if (examinationId !== null && examinationId !== undefined) {
          // 根据取材图id 删除数据库中的相关数据
          let params = new URLSearchParams()
          params.append('examinationId', examinationId)
          params.append('imagePath', this.uploadList[index].image_path)
          // 根据取材图像id 删除相关信息
          let suc = await this.$http.post(this.$vue.getData('DELETE_MATERIALS_INFO_URL'), params)
          if (suc.data.result === '1') {
            this.$Notice.success({
              title: this.$t('caseList.messageNotification'),
              desc: this.$t('captureImage.deletedTip')
            })
            this.deleteMaterialFromUploadList(index)
          }
        }
        if (this.editAddmaterialsList.length !== 0) {
          if (this.editAddmaterialsList.length === 1 || this.imageUrl === this.editAddmaterialsList[index].material_base64) {
            this.imageUrl = ''
            this.visible = false
          }
        }
        this.editAddmaterialsList.splice(index, 1)
      }
    },
    /**
     * describe 从uploadList中删除数据
     * @author JKD
     * @data 2019/4/24 11:01
     */
    deleteMaterialFromUploadList (index) {
      var material_base64 = this.uploadList[index].material_base64
      if (this.uploadList.length === 1 || this.imageUrl === material_base64) {
        this.imageUrl = ''
        this.visible = false
      }
      this.uploadList.splice(index, 1)
    }
  },
  watch: {
    'uploadList': function () {
      this.$emit('getUploadList', this.uploadList)
    },
    'editAddmaterialsList': function () {
      this.$emit('getEditAddmaterialsList', this.editAddmaterialsList)
    }
  },
  beforeMount () {
    this.$vue = this
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .upload-list{
    float: left;
    display: inline-block;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .upload-list img{
    width: 100%;
    height: 100%;
  }
  .upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .upload-list:hover .upload-list-cover{
    display: block;
  }
  .upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/addCase/DrawingImageManagement.vue